module.exports = __webpack_public_path__ + "static/img/01.0259388.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/store/01.jpg
// module id = N6G0
// module chunks = 0